export default __webpack_public_path__ + "images/088af41ee826e668673a5fa0c4790aba-electronic_music_small.webp";